import React, { useEffect } from 'react'
import './Style.css'
import AOS from 'aos';
import 'aos/dist/aos.css';
import './Style.css'
import Kaku from '../Images/Kaku.jpg'
import Pic from '../Images/profile-pic.png'
import Wave from '../Images/Wavy BG4.png'

export default function Section4() {
    useEffect(() => {
        AOS.init();
    }, [])
    return (
        //    Section 4 class is "section5" by mistake
        <>
            <section className="section5">
                <div className="s5-text-container">
                    <span className="s5-floater">LIL ABOUT ME</span>
                    <h1 className="s5-title">There's Something In the Legend Talking About Us !!</h1>
                    <p className="s5-description">I've always been passionate about educating young minds. With a teaching experience of 20+ years, over the years, I've gained valuable experience honing my skills and updated myself with the latest trends and technologies.
                        I started with the vision of transforming the education industry from marks and bookish knowledge into producing industry ready students. It's a platform where we aim to the best results.
                        I'm always eager to connect with fellow enthusiasts, learners, and professionals in the education niche. Whether you have questions or feedback, feel free to contact me on my LinkedIn or Instagram.
                        <br /> <br />
                        Thank you for visiting, I hope you find value in our service!
                        <br />
                        Warm regards,
                        <br />
                        Yashpal Singh
                    </p>
                </div>
                <div className="s5-profile-container">
                    <img src={Pic} className="s5-profile" alt="" data-aos='zoom-in' data-aos-offset='300' />
                </div>
            </section>
            {/* <img src={Wave} className="stacks" alt="" /> */}
        </>

    )
}
